var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.needRegister)?_c('div',[_vm._v("\n        你尚未注册系统，请通过手机号注册.\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }